<template>
  <div style="display: inline-block;">
    <span @click="show()">
      <slot></slot>
    </span>
    <el-dialog v-if="dialogFormVisible" class="el-dialog-lg" :close-on-click-modal="false" :modal="!mobiletype && !trackTask" :visible.sync="dialogFormVisible" width="100%" :fullscreen="!mobiletype" @close="closeDialog()">
      <div class="hearderLogo" v-if="!mobiletype&&!trackTask">
          <HeaderSimple></HeaderSimple>
      </div>
      <div class="trackBody">
        <h3 class="text-center trackTitle">包裹跟踪</h3>
        <div class="leftContent">
          <ul>
            <li v-for="(line,index) in groupOrderLine" class="order-line clearfix" :key="index">
              <div class="img-container">
                <a :href='order.business.website.substr(0,7).toLowerCase() == "http://" || order.business.website.substr(0,8).toLowerCase() == "https://" ? order.business.website : "http://"+ order.business.website' target="_blank">
                  <img v-if="line.picture || line.image_info" :src="line.picture || line.image_info.image"/>
                  <img v-else src="https://pic.joyorders.com/blank.png"/>
                  <span class="goodsNum" v-if="line.number>1">{{line.number}}</span>
                </a>
              </div>
              <div class="order-des">
                <p class="name"><a :href='order.business.website.substr(0,7).toLowerCase() == "http://" || order.business.website.substr(0,8).toLowerCase() == "https://"  ? order.business.website : "http://"+ order.business.website' target="_blank">{{showProductName(line)}}</a></p>
                <div class="spec">
                  <span v-show="!line.isHideSpecLabel">规格：</span>
                  <span v-html="formatSpec(line.spec,line)"></span>
                </div>
                <p class="name" style="color:#888888" v-if="line.image_info && line.image_info.remark">备注：{{line.image_info.remark}}</p>
              </div>
            </li>
          </ul>
          <el-col :span="24" style="margin-top:72px;" class="mobile_address">
              <p class="title" style="margin-bottom: 7px;">寄至</p>
              <SingleAddress :address="normal_address_show?order.address:order.order_address"></SingleAddress>
            </el-col>
        </div>        
        <div class="rightContent">
          <dl>
            
            <div v-if="!shipping_info.terminal_express && !shipping_info.loading && !shipping_info.transport_express && !shipping_info.express" style="margin-top:20px;margin-bottom: 40px;color:#666666">暂无物流</div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="商家物流" name="third" v-if="shipping_info.AWB">
                <div v-if="!shipping_info.AWB_Array">
                  <div v-if="shipping_info.loading" class="text-center">
                    <Loading></Loading>
                  </div>
                  <div v-if="!shipping_info.loading" style="max-height:270px;overflow-y: auto;">
                    <div v-if="!shipping_info.Traces && !shipping_info.data && shipping_info.AWB != 0 && !shipping_info.ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">暂无物流</div>
                    <div v-if="!shipping_info.Traces && (!shipping_info.data || !shipping_info.data.length) && shipping_info.AWB != 0 && shipping_info.ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">请访问<a :href="shipping_info.ship_url" target="_blank">物流跟踪链接</a>查看</div>
                    <div v-if="shipping_info.AWB && shipping_info.AWB == 0" style="margin-top:20px;margin-bottom: 40px;color:#666666">此包裹使用了无跟踪的物流.</div>
                    <dd v-for="trace in shipping_info.data">
                      <el-row type="flex">
                        <el-col :span="6" class="date">{{trace.ftime }}</el-col>
                        <el-col :span="16">
                          <div class="express-detail">
                            <!--<div class="border"></div>-->
                            {{trace.context}}
                          </div>
                        </el-col>
                      </el-row>
                    </dd>
                  </div>
                </div>
                <div v-else>
                  <el-tabs v-model="shipping_info.active_AWB">
                    <el-tab-pane v-for="(a,index) in shipping_info.AWB_Array_Reverse" :key="index" :label="'包裹'+(shipping_info.AWB_Array_Reverse.length-index)" :name="a.AWB">
                      <template v-if="a.data">
                        <div style="max-height:270px;overflow-y: auto;">
                          <div v-if="!a.data.data && !a.ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">暂无物流</div>
                          <div v-if="!a.data.data && a.ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">请访问<a :href="a.ship_url" target="_blank">物流跟踪链接</a>查看</div>
                          <div v-if="a.data.nu && a.data.nu == 0" style="margin-top:20px;margin-bottom: 40px;color:#666666">此包裹使用了无跟踪的物流.</div>
                          <dd v-for="trace in a.data.data">
                            <el-row type="flex">
                              <el-col :span="6" class="date">{{trace.ftime }}</el-col>
                              <el-col :span="16">
                                <div class="express-detail">
                                  <!--<div class="border"></div>-->
                                  {{trace.context}}
                                </div>
                              </el-col>
                            </el-row>
                          </dd>
                        </div>
                      </template>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-tab-pane>
              <el-tab-pane label="转运物流" name="second" v-if="normal_address_show && shipping_info.transport_store_number">
                <div v-if="!shipping_info.transport_Array">
                  <div v-if="shipping_info.loading" class="text-center">
                    <Loading></Loading>
                  </div>
                  <div  v-if="!shipping_info.loading" style="max-height:270px;overflow-y: auto;">
                    <div v-if="(!shipping_info.transport_traces || (!shipping_info.transport_traces.Traces && !shipping_info.transport_traces.data)) && shipping_info.transport_store_number != 0 && !shipping_info.transport_ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">暂无物流</div>
                    <div v-if="(!shipping_info.transport_traces || (!shipping_info.transport_traces.Traces && !shipping_info.transport_traces.data)) && shipping_info.transport_store_number != 0 && shipping_info.transport_ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">请访问<a :href="shipping_info.transport_ship_url" target="_blank">物流跟踪链接</a>查看</div>
                    <div v-if="shipping_info.transport_store_number && shipping_info.transport_store_number == 0" style="margin-top:20px;margin-bottom: 40px;color:#666666">此包裹使用了无跟踪的物流.</div>
                    <template v-if="shipping_info.transport_traces && shipping_info.transport_traces.Traces">
                      <dd v-for="trace in shipping_info.transport_traces.Traces">
                      <el-row type="flex">
                        <el-col :span="6" class="date">{{trace.AcceptTime}}</el-col>
                        <el-col :span="16">
                          <div class="express-detail">
                            {{trace.AcceptStation}}
                          </div>
                        </el-col>
                      </el-row>
                    </dd>
                    </template>
                    <template v-if="shipping_info.transport_traces && shipping_info.transport_traces.data">
                      <dd v-for="trace in shipping_info.transport_traces.data">
                      <el-row type="flex">
                        <el-col :span="6" class="date">{{trace.ftime}}</el-col>
                        <el-col :span="16">
                          <div class="express-detail">
                            {{trace.context}}
                          </div>
                        </el-col>
                      </el-row>
                    </dd>
                    </template>
                  </div>
                </div>
                <div v-else>
                  <el-tabs v-model="shipping_info.active_Transport">
                    <el-tab-pane v-for="(a,index) in shipping_info.transport_Array_Reverse" :key="index" :label="'包裹'+(shipping_info.transport_Array_Reverse.length-index)" :name="a.AWB">
                      <template v-if="a.data">
                        <div style="max-height:270px;overflow-y: auto;">
                          <div v-if="!a.data.data && !a.ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">暂无物流</div>
                          <div v-if="!a.data.data && a.ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">请访问<a :href="a.ship_url" target="_blank">物流跟踪链接</a>查看</div>
                          <div v-if="a.data.nu && a.data.nu == 0" style="margin-top:20px;margin-bottom: 40px;color:#666666">此包裹使用了无跟踪的物流.</div>
                          <dd v-for="trace in a.data.data">
                            <el-row type="flex">
                              <el-col :span="6" class="date">{{trace.ftime }}</el-col>
                              <el-col :span="16">
                                <div class="express-detail">
                                  <!--<div class="border"></div>-->
                                  {{trace.context}}
                                </div>
                              </el-col>
                            </el-row>
                          </dd>
                        </div>
                      </template>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-tab-pane>
              <el-tab-pane label="终端物流" name="first" v-if="normal_address_show && shipping_info.terminal_store_number">
                <div v-if="!shipping_info.terminal_Array">
                  <div v-if="shipping_info.loading" class="text-center">
                    <Loading></Loading>
                  </div>
                  <div v-if="!shipping_info.loading" style="max-height:270px;overflow-y: auto;">            
                    <div v-if="(!shipping_info.terminal_traces || (!shipping_info.terminal_traces.Traces && !shipping_info.terminal_traces.data)) && shipping_info.terminal_store_number != 0 && !shipping_info.terminal_ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">暂无物流</div>
                    <div v-if="(!shipping_info.terminal_traces || (!shipping_info.terminal_traces.Traces && !shipping_info.terminal_traces.data)) && shipping_info.terminal_store_number != 0 && shipping_info.terminal_ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">请访问<a :href="shipping_info.terminal_ship_url" target="_blank">物流跟踪链接</a>查看</div>
                    <div v-if="shipping_info.terminal_store_number && shipping_info.terminal_store_number == 0" style="margin-top:20px;margin-bottom: 40px;color:#666666">此包裹使用了无跟踪的物流.</div>
                    <template v-if="shipping_info.terminal_traces && shipping_info.terminal_traces.Traces">
                      <dd v-for="trace in shipping_info.terminal_traces.Traces">
                      <el-row type="flex">
                        <el-col :span="6" class="date">{{trace.AcceptTime}}</el-col>
                        <el-col :span="16">
                          <div class="express-detail">
                            {{trace.AcceptStation}}
                          </div>
                        </el-col>
                      </el-row>
                    </dd>
                    </template>
                    <template v-if="shipping_info.terminal_traces && shipping_info.terminal_traces.data">
                      <dd v-for="trace in shipping_info.terminal_traces.data">
                      <el-row type="flex">
                        <el-col :span="6" class="date">{{trace.ftime}}</el-col>
                        <el-col :span="16">
                          <div class="express-detail">
                            {{trace.context}}
                          </div>
                        </el-col>
                      </el-row>
                    </dd>
                    </template>
                  </div>
                </div>
                <div v-else>
                  <el-tabs v-model="shipping_info.active_Terminal">
                    <el-tab-pane v-for="(a,index) in shipping_info.terminal_Array_Reverse" :key="index" :label="'包裹'+(shipping_info.terminal_Array_Reverse.length-index)" :name="a.AWB">
                      <template v-if="a.data">
                        <div style="max-height:270px;overflow-y: auto;">
                          <div v-if="!a.data.data && !a.ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">暂无物流</div>
                          <div v-if="!a.data.data && a.ship_url" style="margin-top:20px;margin-bottom: 40px;color:#666666">请访问<a :href="a.ship_url" target="_blank">物流跟踪链接</a>查看</div>
                          <div v-if="a.data.nu && a.data.nu == 0" style="margin-top:20px;margin-bottom: 40px;color:#666666">此包裹使用了无跟踪的物流.</div>
                          <dd v-for="trace in a.data.data">
                            <el-row type="flex">
                              <el-col :span="6" class="date">{{trace.ftime }}</el-col>
                              <el-col :span="16">
                                <div class="express-detail">
                                  <!--<div class="border"></div>-->
                                  {{trace.context}}
                                </div>
                              </el-col>
                            </el-row>
                          </dd>
                        </div>
                      </template>
                    </el-tab-pane>
                  </el-tabs>
                </div>              
              </el-tab-pane>
              
              
            </el-tabs>
            
          </dl>
          <el-row :gutter="20" v-if="!trackTask">
            <el-col :span="24">
              <div class="order-info">
                <p class="expressList">商家订单</p>
                <p class="expressList" style="margin-left:10px;margin-right:20px;">{{ groupOrderLine[0].business_order_no || order.business_order_no }}</p>
                <div class="editIcon" v-if="(maishouenable || order.business_shipping_account_id==account_id || role==2) && !openExpress" @click="editOrderEdit"></div>
                <el-form :model="form" class="dialog-form" style="margin-top:22px;" v-if="openOrderEdit">
                  <ul class="error-messages" v-if="!isEmptyErrors">
                    <li v-for="error in errors">{{error[0].message}}</li>
                  </ul>
                  <el-form-item prop="business_order_no" >
                    <YueDanIpt model="business_order_no" :object="form" placeholder="商家订单号"></YueDanIpt>
                  </el-form-item>
                  <el-form-item >
                    <div class="cancel" @click="cancelOrderEdit()">取消</div>
                    <el-button type="primary" style="width:49%;height:45px;" :loading="ordernoloading" @click="submitOrderEdit()">保存</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="order-info" v-if="shipping_info.need_transport == '1'">
                <p class="expressList">商家物流</p>
                <p class="expressList" style="margin-left:10px;margin-right:20px;" v-if="!openExpress && !shipping_info.express">暂无</p>
                <p class="expressList" style="margin-left:10px;margin-right:20px;" v-if="!openExpress && shipping_info.express">{{shipping_info.express}}</p>
                <p v-if="!shipping_info.AWB_Array || shipping_info.AWB_Array.length==0" class="expressList">
                  <a v-if="!openExpress && shipping_info.express && shipping_info.ship_url" :href="shipping_info.ship_url" target="_blank" >{{shipping_info.AWB}}</a>
                  <label v-if="!openExpress && shipping_info.express && !shipping_info.ship_url">{{shipping_info.AWB}}</label>
                </p>
                <p v-else class="expressList">
                  <span v-for="(a,index) in shipping_info.AWB_Array">
                    <a v-if="!openExpress && shipping_info.express && a.ship_url" :href="a.ship_url" target="_blank">{{a.AWB}}</a>
                    <label v-if="!openExpress && shipping_info.express && !a.ship_url">{{a.AWB}}</label>
                    <span v-if="index<shipping_info.AWB_Array.length-1">| </span>
                  </span>
                </p>
                <div class="editIcon" v-if="(maishouenable || order.business_shipping_account_id==account_id || role==2) && !openExpress && this.groupOrderLine[0].status != '2'" @click="edit('express')"></div>
                <el-form ref="form" :model="form" :rules="rules" class="dialog-form" style="margin-top:22px;" v-if="openExpress">
                  <ul class="error-messages" v-if="!isEmptyErrors">
                    <li v-for="error in errors">{{error[0].message}}</li>
                  </ul>
                  <el-form-item prop="express">
                    <!--<el-autocomplete
                      class="inline-input"
                      style="width:100%;height:50px;"
                      v-model="express"
                      :fetch-suggestions="querySearch"
                      placeholder="请输入快递公司"
                      :trigger-on-focus="false"
                      @select="handleSelect"
                    ></el-autocomplete>-->
                    <el-select style="width:100%;height:50px;"
                      v-model="express"
                      clearable
                      filterable
                      :filter-method="remoteSearch"
                      class="input-width customheight_auto"
                      @change="handleSelect"
                      placeholder="请输入快递公司">
                      <el-option
                        v-for="item in remoteExpresses"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="AWB" >
                    <YueDanIpt model="AWB" :object="form" placeholder="物流单号" v-on:blur="blur"></YueDanIpt>
                  </el-form-item>
                  <el-row >
                    <el-col :span="24" style="font-size: 10px;margin-bottom: 10px;">
                      * 若是无跟踪物流,请输入数字“0”
                    </el-col>
                  </el-row>
                  <el-form-item prop="tracking_url" >
                    <YueDanIpt model="tracking_url" :object="form" placeholder="物流跟踪网址" :readonly="readonly"></YueDanIpt>
                  </el-form-item>
                  <el-form-item >
                    <div class="cancel" @click="cancel('express')">取消</div>
                    <el-button type="primary" style="width:49%;height:45px;" :loading="expressloading" @click="submit('express')">保存</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="order-info" v-if="normal_address_show && shipping_info.need_transport == '1'">
                <p class="expressList">转运物流</p>
                <p class="expressList" style="margin-left:10px;margin-right:20px;" v-if="!openTransport && !shipping_info.transport_express">暂无</p>
                <p class="expressList" style="margin-left:10px;margin-right:20px;" v-if="!openTransport && shipping_info.transport_express">{{shipping_info.transport_express}}</p>
                <p v-if="!shipping_info.transport_Array || shipping_info.transport_Array.length==0" class="expressList">
                  <a :href="shipping_info.transport_ship_url" target="_blank" v-if="!openTransport && shipping_info.transport_express && shipping_info.transport_ship_url">{{shipping_info.transport_store_number}}</a>
                  <span v-if="!openTransport && shipping_info.transport_express && !shipping_info.transport_ship_url">{{shipping_info.transport_store_number}}</span>
                </p>
                <p v-else class="expressList">
                  <span v-for="(a,index) in shipping_info.transport_Array">
                    <a :href="a.ship_url" target="_blank" v-if="!openTransport && shipping_info.transport_express && a.ship_url">{{a.AWB}}</a>
                    <span v-if="!openTransport && shipping_info.transport_express && !a.ship_url">{{a.AWB}}</span>
                    <span v-if="index<shipping_info.transport_Array.length-1">| </span>
                  </span>
                </p>
                <div class="editIcon" v-if="(maishouenable || order.transport_shipping_account_id==account_id || role==2) && !openTransport" @click="edit('transport')"></div>
                <el-form ref="form" :model="form" :rules="rules" class="dialog-form" style="margin-top:22px;" v-if="openTransport">
                  <ul class="error-messages" v-if="!isEmptyErrors">
                    <li v-for="error in errors">{{error[0].message}}</li>
                  </ul>
                  <el-form-item prop="transport_express_id">
                    <!--<el-autocomplete
                      class="inline-input"
                      style="width:100%;height:50px;"
                      v-model="transport_express"
                      :fetch-suggestions="transportquerySearch"
                      placeholder="请输入快递公司"
                      :trigger-on-focus="false"
                      @select="transporthandleSelect"
                    ></el-autocomplete>-->
                    <el-select style="width:100%;height:50px;"
                      v-model="transport_express"
                      clearable
                      filterable
                      :filter-method="remotetransportSearch"
                      class="input-width customheight_auto"
                      @change="transporthandleSelect"
                      placeholder="转运公司">
                      <el-option
                        v-for="item in remoteTrasports"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="transport_store_number" >
                    <YueDanIpt model="transport_store_number" :object="form" placeholder="转运单号" v-on:blur="transportBlur"></YueDanIpt>
                  </el-form-item>
                  <el-form-item prop="transport_ship_url" >
                    <YueDanIpt model="transport_ship_url" :object="form" placeholder="物流跟踪网址" :readonly="readonly"></YueDanIpt>
                  </el-form-item>
                  <el-form-item >
                    <div class="cancel" @click="cancel('transport')">取消</div>
                    <el-button type="primary" style="width:49%;height:45px;" :loading="transportloading" @click="submit('transport')">保存</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="order-info" v-if="normal_address_show && shipping_info.need_transport == '1'">
                <p class="expressList">终端物流</p>
                <p class="expressList" style="margin-left:10px;margin-right:20px;" v-if="!openTerminal && !shipping_info.terminal_express">暂无</p>
                <p class="expressList" style="margin-left:10px;margin-right:20px;" v-if="!openTerminal && shipping_info.terminal_express">{{shipping_info.terminal_express}}</p>
                <p v-if="!shipping_info.terminal_Array || shipping_info.terminal_Array.length==0" class="expressList">
                  <a :href="shipping_info.terminal_ship_url" target="_blank" v-if="!openTerminal && shipping_info.terminal_express && shipping_info.terminal_ship_url">{{shipping_info.terminal_store_number}}</a>
                  <span v-if="!openTerminal && shipping_info.terminal_express && !shipping_info.terminal_ship_url">{{shipping_info.terminal_store_number}}</span>
                </p>
                <p v-else class="expressList">
                  <span v-for="(a,index) in shipping_info.terminal_Array">
                    <a :href="a.ship_url" target="_blank" v-if="!openTerminal && shipping_info.terminal_express && a.ship_url">{{a.AWB}}</a>
                    <span v-if="!openTerminal && shipping_info.terminal_express && !a.ship_url">{{a.AWB}}</span>
                    <span v-if="index<shipping_info.terminal_Array.length-1">| </span>
                  </span>
                </p>
                <div class="editIcon" v-if="(maishouenable || order.transport_shipping_account_id==account_id || role==2) && !openTerminal" @click="edit('terminal')"></div>
                <el-form ref="form" :model="form" :rules="rules" class="dialog-form" style="margin-top:22px;" v-if="openTerminal">
                  <ul class="error-messages" v-if="!isEmptyErrors">
                    <li v-for="error in errors">{{error[0].message}}</li>
                  </ul>
                  <el-form-item prop="terminal_express_id">
                    <!--<el-autocomplete
                      class="inline-input"
                      style="width:100%;height:50px;"
                      v-model="terminal_express"
                      :fetch-suggestions="terminalquerySearch"
                      placeholder="请输入快递公司"
                      :trigger-on-focus="false"
                      @select="terminalhandleSelect"
                    ></el-autocomplete>-->
                    <el-select style="width:100%;height:50px;"
                      v-model="terminal_express"
                      clearable
                      filterable
                      :filter-method="remotetterminalSearch"
                      class="input-width customheight_auto"
                      @change="terminalhandleSelect"
                      placeholder="请输入快递公司">
                      <el-option
                        v-for="item in remoteTerminals"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item prop="terminal_store_number" >
                    <YueDanIpt model="terminal_store_number" :object="form" placeholder="物流单号" v-on:blur="terminalBlur"></YueDanIpt>
                  </el-form-item>
                  <el-row >
                    <el-col :span="24" style="font-size: 10px;margin-bottom: 10px;">
                      * 若是无跟踪物流,请输入数字“0”
                    </el-col>
                  </el-row>
                  <el-form-item prop="terminal_ship_url" >
                    <YueDanIpt model="terminal_ship_url" :object="form" placeholder="物流跟踪网址" :readonly="readonly"></YueDanIpt>
                  </el-form-item>
                  <el-form-item>
                    <div class="cancel" @click="cancel('terminal')">取消</div>
                    <el-button type="primary" style="width:49%;height:45px;" :loading="terminalloading" @click="submit('terminal')">保存</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="order-info" v-if="shipping_info.need_transport == '0'">
                <p class="expressList">无需物流</p>
              </div>
              <div style="border-top: 1px solid #D7D7D7;margin-top: 10px;padding: 10px 0;">
                商家发货委托：
                <!--<span>{{order.business_shipping_entrust==1?(order.business_shipping_username?order.business_shipping_username:'是'):'无'}}</span>-->
                {{order.business_shipping_username?order.business_shipping_username:'暂不委托'}}
              </div>
              <div>
                转运发货委托：
                <!--<span>{{order.transport_shipping_entrust==1?(order.transport_shipping_username?order.transport_shipping_username:'是'):'无'}}</span>-->
                {{order.transport_shipping_username?order.transport_shipping_username:'暂不委托'}}
              </div>
            </el-col>
            
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../../services/api.js'
import SingleAddress from '../../publish_task/address/SingleAddress'
import HeaderSimple from '../../../components/HeaderSimple'
import YueDanIpt from '../../../components/YueDanIpt'
import Loading from '../../../components/Loading'
import { specOrder,SPEC_MAPPER } from '../../../services/constant.js'
import {showProductName,formatSpec} from '../../../services/tools.js'
let _ = require('lodash')
const MaxCharNumber = 100

export default {
  name: 'AddAddress',
  props: ['order', 'groupOrderLine','isSingle','mobiletype','trackTask','shippingArr','normal_address_show'],
  components: {
    SingleAddress: SingleAddress,
    HeaderSimple: HeaderSimple,
    YueDanIpt: YueDanIpt,
    Loading: Loading
  },
  computed: {
    maishouenable(){
      //包含系统买手管理员role=1，商家买手管理员，普通任务买手
      return this.role==1 || this.order.single_account_id==this.account_id || (this.order.merchant_administrator_account_id_list && this.order.merchant_administrator_account_id_list.indexOf(this.account_id)>-1) 
    },
  },
  data () {
    return {
      showProductName:showProductName,
      formatSpec:formatSpec,
      update_order:{},
      isChange:false,
      old_AWB:'',
      old_transport_store_number:'',
      old_terminal_store_number:'',
      remoteTrasports:[],
      remoteExpresses:[],
      remoteTerminals:[],
      express: '',
      transport_express: '',
      terminal_express: '',
      activeName: 'third',
      dialogFormVisible: false,
      loading: false,
      shipping_info:  {
        loading: true,
        Traces: []
      },
      isEmptyErrors: true,
      readonly: false,
      errors: null,
      expressList: null,
      transportList: null,
      openOrderEdit: false,
      openExpress: false,
      openTransport: false,
      openTerminal: false,
      expressSelect: true,
      transportSelect: true,
      terminalSelect: true,
      form: {
        business_order_no:'',
        AWB: '',
        goods_list: '',
        goods_info:'',
        express: '',
        express_id:'',
        tracking_url: '',
        transport_express_id: '',
        transport_store_number: '',
        transport_ship_url: '',
        terminal_express_id: '',
        terminal_store_number: '',
        terminal_ship_url: '',

      },
      ordernoloading:false,
      expressloading:false,
      transportloading:false,
      terminalloading:false,
      rules: {
        express: [
          { required: true, message: '快递公司是必选项', trigger: 'change' }
        ],
        AWB: [
          { required: true, message: '物流单号是必填项', trigger: 'blur' },
          { min: 0, max: MaxCharNumber, message: '物流单号长度在 0 到 100 个字符', trigger: 'blur' }
        ],
      },
      account_id:this.$localStorage.get('account_id'),
      role:this.$localStorage.get('role')
    }
  },
  methods: {
    closeDialog(){
      this.showForm = false;
      this.openTransport = false;
      this.openOrderEdit = false
      this.openExpress = false;
      this.openTerminal = false;
      this.isChange=true;
      if(this.isChange){
        //this.order.groupOrderLines = _.groupBy(this.update_order.goods_list, 'package_id')
        this.getInfo();
        this.$emit('updateGroupLine',this.update_order)
      }
    },
    show () {
      this.dialogFormVisible = true
      this.openOrderEdit = false
      this.openExpress = false
      this.openTransport = false
      this.openTerminal = false
      this.form.business_order_no = this.groupOrderLine[0].business_order_no?this.groupOrderLine[0].business_order_no:this.order.business_order_no
      this.getInfo()
    },
    async getInfo () {
      this.shipping_info.loading = true
      let res = await api.post(this, {
        path: 'order.php',
        api: 'package_tracking',
        data: {
          order_id: this.order.id,
          shipping_id: this.groupOrderLine[0].shipping_id,
          update_time: this.order.update_time,
          ignore_third_api: 1
        }
      })
        res = res.body
        if (res.status == 'ok') {
          
        this.shipping_info.loading = false
        let result
        try {
          result = res.result || '{}'
          result = JSON.parse(result)
        } catch(e) {
          result = res.result || {}
        }

        
        if (result.Traces && result.support == '2') {
          if(result.Traces.length > 0){
            result.Traces = _.orderBy(result.Traces, ['AcceptTime'], ['desc'])
          }else{
            result.Traces = ''
          }
        }
        if(result.data && result.support == '3') {
          if(result.data.length <= 0) {
            result.data = ''
          }
        }
        if(result){
          if(result.terminal_traces && result.terminal_traces.Traces) {
            if(result.terminal_traces.Traces.length <= 0) {
              result.terminal_traces.Traces = ''
            }else{
              result.terminal_traces.Traces = _.orderBy(result.terminal_traces.Traces, ['AcceptTime'], ['desc'])
            }
          }
          if(result.transport_traces && result.transport_traces.Traces) {
            if(result.transport_traces.Traces.length <= 0) {
              result.transport_traces.Traces = ''
            }
          }
        }
        
        if(this.normal_address_show){
          if(result.terminal_express) {
            this.activeName = 'first'
          }
          if(!result.terminal_express && result.transport_store_number) {
            this.activeName = 'second'
          }
          if(!result.terminal_express && !result.transport_store_number) {
            this.activeName = 'third'
          }
        }
        else
          this.activeName = 'third'
        
        this.shipping_info = result
        this.express = result.express
        this.transport_express = result.transport_express
        this.terminal_express = result.terminal_express
        this.getExpressList()
        this.getTransportCompanyList()
        this.getPackage()
      } 
    },
    async getPackage(){
      this.shipping_info.loading = true
      let sid=this.groupOrderLine[0].shipping_id
      if(this.shippingArr)
        sid=this.shippingArr
      let res = await api.post(this, {
        path: 'order.php',
        api: 'package_tracking',
        data: {
          order_id: this.order.id,
          shipping_id: sid,
          update_time: this.order.update_time,
          ignore_third_api: 0
        }
      })
        res = res.body
        if (res.status == 'ok') {
          
        this.shipping_info.loading = false
        let result
        try {
          result = res.result || '{}'
          result = JSON.parse(result)
        } catch(e) {
          result = res.result || {}
        }

        
        if (result.Traces && result.support == '2') {
          if(result.Traces.length > 0){
            result.Traces = _.orderBy(result.Traces, ['AcceptTime'], ['desc'])
          }else{
            result.Traces = ''
          }
        }
        if(result.data && result.support == '3') {
          if(result.data.length <= 0) {
            result.data = ''
          }
        }
        if(result){
          if(result.terminal_traces && result.terminal_traces.Traces) {
            if(result.terminal_traces.Traces.length <= 0) {
              result.terminal_traces.Traces = ''
            }else{
              result.terminal_traces.Traces = _.orderBy(result.terminal_traces.Traces, ['AcceptTime'], ['desc'])
            }
          }
          if(result.transport_traces && result.transport_traces.Traces) {
            if(result.transport_traces.Traces.length <= 0) {
              result.transport_traces.Traces = ''
            }
          }
        }
        
        if(this.normal_address_show){
          if(result.terminal_express) {
            this.activeName = 'first'
          }
          if(!result.terminal_express && result.transport_store_number) {
            this.activeName = 'second'
          }
          if(!result.terminal_express && !result.transport_store_number) {
            this.activeName = 'third'
          }
        }
        else
          this.activeName = 'third'
        //多个物流单号
        if(result.AWB.indexOf('|')>-1){
          result.AWB_Array=[];
          result.AWB_Array_Reverse=[];
          let t_array=this.shipping_info.ship_url.split('|')
          let t_index=0;
          for(let a in result.AWB_traces_list){
            //if(result.AWB_traces_list[a]){
              result.AWB_Array.push({AWB:a,data:result.AWB_traces_list[a],ship_url:t_array[t_index]})
              result.AWB_Array_Reverse.push({AWB:a,data:result.AWB_traces_list[a],ship_url:t_array[t_index++]})
            //}
          }
          result.AWB_Array_Reverse.reverse()
          if(result.AWB_Array.length)
            result.active_AWB=result.AWB_Array[0].AWB
        }
        if(result.transport_store_number.indexOf('|')>-1){
          result.transport_Array=[];
          result.transport_Array_Reverse=[];
          let t_array=this.shipping_info.transport_ship_url.split('|')
          let t_index=0;
          for(let a in result.transport_traces_list){
            //if(result.transport_traces_list[a]){
              result.transport_Array.push({AWB:a,data:result.transport_traces_list[a],ship_url:t_array[t_index]})
              result.transport_Array_Reverse.push({AWB:a,data:result.transport_traces_list[a],ship_url:t_array[t_index++]})
            //}
          }
          result.transport_Array_Reverse.reverse()
          if(result.transport_Array.length)
            result.active_Transport=result.transport_Array[0].AWB
        }
        if(result.terminal_store_number.indexOf('|')>-1){
          result.terminal_Array=[];
          result.terminal_Array_Reverse=[];
          let t_array=this.shipping_info.terminal_ship_url.split('|')
          let t_index=0;
          for(let a in result.terminal_traces_list){
            //if(result.terminal_traces_list[a]){
              result.terminal_Array.push({AWB:a,data:result.terminal_traces_list[a],ship_url:t_array[t_index]})
              result.terminal_Array_Reverse.push({AWB:a,data:result.terminal_traces_list[a],ship_url:t_array[t_index++]})
            //}
          }
          result.terminal_Array_Reverse.reverse()
          if(result.terminal_Array.length)
            result.active_Terminal=result.terminal_Array[0].AWB
        }
        this.shipping_info = result
        this.express = result.express
        this.transport_express = result.transport_express
        this.terminal_express = result.terminal_express
        this.getExpressList()
        this.getTransportCompanyList()
      }
    },
    async getExpressList () {
      let res = await api.getExpressList(this)
      let arr = []
      _.each(res.body.result,item => {
        if(item.type == '1') {
          arr.push(item)
        }
      })
      this.expressList = arr
      this.form.express = ''
      _.each(this.expressList, item => {
        if(this.shipping_info.express == item.name){
          this.form.express = item.id
        }
      })
      this.form.AWB = this.shipping_info.AWB
      this.form.tracking_url = this.shipping_info.ship_url
      this.form.terminal_express_id = ''
      _.each(this.expressList, item => {
        if(this.shipping_info.terminal_express == item.name){
          this.form.terminal_express_id = item.id
        }
      })
      this.form.terminal_store_number = this.shipping_info.terminal_store_number
      this.form.terminal_ship_url = this.shipping_info.terminal_ship_url
    },
    async getTransportCompanyList () {
      let res = await api.getExpressList(this)
      let arr = []
      _.each(res.body.result,item => {
        if(item.type == '2') {
          arr.push(item)
        }
      })
      this.transportList = arr
      this.form.transport_express_id = ''
      _.each(this.transportList, item => {
        if(this.shipping_info.transport_express == item.name){
          this.form.transport_express_id = item.id
        }
      })
      this.form.transport_store_number = this.shipping_info.transport_store_number
      this.form.transport_ship_url = this.shipping_info.transport_ship_url
    },
    handleClick(tab, event) {
    },
    async querySearch(queryString, cb){
      console.log(queryString)
      let query = {
        keyword: queryString
      }
      let res = await api.getExpressList(this,query)
      let arr = []
      _.each(res.body.result,item => {
        if(item.type == '1') {
          arr.push({value:item.name,id:item.id})
          this.form.express = item.id
        }
      })
      cb(arr)
      this.expressSelect = false
      this.errors = null
      this.isEmptyErrors = true
    },
    async remoteSearch(queryString){
      console.log(queryString)
      let query = {
        keyword: queryString
      }
      let res = await api.getExpressList(this,query)
      this.remoteExpresses=[]
      _.each(res.body.result,item => {
        if(item.type == '1') {
          this.remoteExpresses.push({value:item.name,id:item.id})
          //this.form.express = item.id
        }
      })
      this.expressSelect = false
      this.errors = null
      this.isEmptyErrors = true
    },
    handleSelect (item) {
       //this.form.express = item.id
       this.form.express = item
       if(!item)
          this.remoteExpresses=[]
       this.expressSelect = true
       this.blur(this.form.AWB)
    },
    async transportquerySearch(queryString, cb){
      console.log(queryString)
      let query = {
        keyword: queryString
      }
      let res = await api.getExpressList(this,query)
      let arr = []
      _.each(res.body.result,item => {
        if(item.type == '2') {
          arr.push({value:item.name,id:item.id})
          this.form.transport_express_id = item.id
        }
      })
      cb(arr)
      this.transportSelect = false
      this.errors = null
      this.isEmptyErrors = true
    },
    async remotetransportSearch(queryString){
      let query = {
        keyword: queryString
      }
      let res = await api.getExpressList(this,query)
      this.remoteTrasports=[]
      _.each(res.body.result,item => {
        if(item.type == '2') {
          this.remoteTrasports.push({value:item.name,id:item.id})
          this.form.transport_express_id = item.id
        }
      })
      this.transportSelect = false
      this.errors = null
      this.isEmptyErrors = true
    },
    transporthandleSelect (item) {
        //this.form.transport_express_id = item.id
        this.form.transport_express_id = item
        if(!item)
          this.remoteTrasports=[]
        this.transportSelect = true
        this.transportBlur(this.form.transport_store_number)
    },
    async terminalquerySearch(queryString, cb){
      console.log(queryString)
      let query = {
        keyword: queryString
      }
      let res = await api.getExpressList(this,query)
      let arr = []
      _.each(res.body.result,item => {
        if(item.type == '1') {
          arr.push({value:item.name,id:item.id})
          this.form.terminal_express_id = item.id
        }
      })
      cb(arr)
      this.terminalSelect = false
      this.errors = null
      this.isEmptyErrors = true
    },
    async remotetterminalSearch(queryString){
      let query = {
        keyword: queryString
      }
      let res = await api.getExpressList(this,query)
      this.remoteTerminals = []
      _.each(res.body.result,item => {
        if(item.type == '1') {
          this.remoteTerminals.push({value:item.name,id:item.id})
          this.form.terminal_express_id = item.id
        }
      })
      this.terminalSelect = false
      this.errors = null
      this.isEmptyErrors = true
    },
     terminalhandleSelect (item) {
        //this.form.terminal_express_id = item.id
        this.form.terminal_express_id = item
        if(!item)
          this.remoteTerminals=[]
        this.terminalBlur(this.form.terminal_store_number)
        this.terminalSelect = true
    },
    /*blur (data) {
      if(!this.expressSelect) {
        return
      }
      if(this.express && data && data != '0'){
        this.readonly = false
        _.each(this.expressList, item => {
          if(this.form.express == item.id){
            this.form.tracking_url = ''
            let str
            if(item.tracking_url){
              if(this.shipping_info.AWB_Array){
                this.shipping_info.AWB_Array.forEach((a)=>{
                  let AWB=a.AWB
                  if(a.AWB && a.AWB.indexOf(":")>-1)
                    AWB=a.AWB.substring(0,a.AWB.indexOf(":"))
                  if(item.tracking_url.indexOf('{0}') > -1) {
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    a.ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                  }else if(item.tracking_url.indexOf('{-1}') > -1){
                    if(item.tracking_url){
                      str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                      a.ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                    }
                  }else{
                    a.ship_url = item.tracking_url
                  }
                  this.form.tracking_url+=a.ship_url+"|"
                })
                this.form.tracking_url=this.form.tracking_url.substring(0,this.form.tracking_url.length-1)
              }
              else{
                let AWB=this.form.AWB
                  if(this.form.AWB && this.form.AWB.indexOf(":")>-1)
                    AWB=this.form.AWB.substring(0,this.form.AWB.indexOf(":"))
                if(item.tracking_url.indexOf('{0}') > -1) {
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    this.form.tracking_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                }else if(item.tracking_url.indexOf('{-1}') > -1){
                  if(item.tracking_url){
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    this.form.tracking_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                  }
                }else{
                  this.form.tracking_url = item.tracking_url
                }
              }
            }

          }
        })
        return
      }else if(this.express && data && data == '0'){
        this.form.tracking_url = ''
        this.readonly = true
      }
    },*/
    blur (data) {
      if(!this.expressSelect) {
        return
      }
      if(this.express && data && data != '0'){
        this.readonly = false
        _.each(this.expressList, item => {
          if(this.form.express == item.id){
            this.form.tracking_url = ''
            let str
            if(item.tracking_url){
              let arr=data.split('|')
              if(arr.length>1){
                arr.forEach((a)=>{
                  let AWB=a
                  let ship_url=''
                  if(a && a.indexOf(":")>-1)
                    AWB=a.substring(0,a.indexOf(":"))
                  if(item.tracking_url.indexOf('{0}') > -1) {
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                  }else if(item.tracking_url.indexOf('{-1}') > -1){
                    if(item.tracking_url){
                      str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                      ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                    }
                  }else{
                    ship_url = item.tracking_url
                  } 
                  this.form.tracking_url+=ship_url+"|"
                })
                this.form.tracking_url=this.form.tracking_url.substring(0,this.form.tracking_url.length-1)
              }
              else{
                let AWB=this.form.AWB
                  if(this.form.AWB && this.form.AWB.indexOf(":")>-1)
                    AWB=this.form.AWB.substring(0,this.form.AWB.indexOf(":"))
                if(item.tracking_url.indexOf('{0}') > -1) {
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    this.form.tracking_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                }else if(item.tracking_url.indexOf('{-1}') > -1){
                  if(item.tracking_url){
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    this.form.tracking_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                  }
                }else{
                  this.form.tracking_url = item.tracking_url
                }
              }
            }

          }
        })
        return
      }else if(this.express && data && data == '0'){
        this.form.tracking_url = ''
        this.readonly = true
      }
    },
    transportBlur (data) {
      if(!this.transportSelect) {
        return
      }
      if(this.transport_express && data && data != '0'){
        this.readonly = false
        _.each(this.transportList, item => {
          if(this.form.transport_express_id == item.id){
            this.form.transport_ship_url = ''
            let str
            if(item.tracking_url) {
              let arr=data.split('|')
              if(arr.length>1){
                arr.forEach((a)=>{
                  let AWB=a
                  let ship_url=''
                  if(a && a.indexOf(":")>-1)
                    AWB=a.substring(0,a.AWB.indexOf(":"))
                  if(item.tracking_url.indexOf('{0}') > -1) {
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                  }else if(item.tracking_url.indexOf('{-1}') > -1){
                    if(item.tracking_url){
                      str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                      ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                    }
                  }else{
                    ship_url = item.tracking_url
                  }
                  this.form.transport_ship_url+=ship_url+"|"
                })
                this.form.transport_ship_url=this.form.transport_ship_url.substring(0,this.form.transport_ship_url.length-1)
              }
              else{
                let AWB=this.form.transport_store_number
                if(this.form.transport_store_number && this.form.transport_store_number.indexOf(":")>-1)
                    AWB=this.form.transport_store_number.substring(0,this.form.transport_store_number.indexOf(":"))
                if(item.tracking_url.indexOf('{0}') > -1){
                  str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                  this.form.transport_ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                }else if(item.tracking_url.indexOf('{-1}') > -1){
                  if(item.tracking_url){
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    this.form.transport_ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                  }
                }else{
                  this.form.transport_ship_url = item.tracking_url
                }
              }
            }

          }
        })
        return
      }else if(this.terminal_express && data && data == '0'){
        this.form.transport_ship_url = ''
        this.readonly = true
      }
    },
    terminalBlur (data) {
      if(!this.terminalSelect) {
        return
      }
      if(this.terminal_express && data && data != '0'){
        this.readonly = false
        _.each(this.expressList, item => {
          
          if(this.form.terminal_express_id == item.id){
            this.form.terminal_ship_url = ''
            let str
            if(item.tracking_url){
              let arr=data.split('|')
              if(arr.length>1){
                arr.forEach((a)=>{
                  let AWB=a
                  let ship_url=''
                  if(a.AWB && a.indexOf(":")>-1)
                    AWB=a.AWB.substring(0,a.indexOf(":"))
                  if(item.tracking_url.indexOf('{0}') > -1) {
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                  }else if(item.tracking_url.indexOf('{-1}') > -1){
                    if(item.tracking_url){
                      str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                      ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                    }
                  }else{
                    ship_url = item.tracking_url
                  }
                  this.form.terminal_ship_url+=ship_url+"|"
                })
                this.form.terminal_ship_url=this.form.terminal_ship_url.substring(0,this.form.terminal_ship_url.length-1)
              }
              else{
                let AWB=this.form.terminal_store_number
                if(this.form.terminal_store_number && this.form.terminal_store_number.indexOf(":")>-1)
                    AWB=this.form.terminal_store_number.substring(0,this.form.terminal_store_number.indexOf(":"))
                if(item.tracking_url.indexOf('{0}') > -1) {
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    this.form.terminal_ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                }else if(item.tracking_url.indexOf('{-1}') > -1){
                  if(item.tracking_url){
                    str = item.tracking_url.substring(item.tracking_url.indexOf('{'),item.tracking_url.indexOf('}')+1)
                    this.form.terminal_ship_url = item.tracking_url.replace(str,AWB.replace(/ /g,''))
                  }
                }else{
                  this.form.terminal_ship_url = item.tracking_url
                }
              }
            }

            
          }
        })
        return
      }else if(this.terminal_express && data && data == '0'){
        this.form.terminal_ship_url = ''
        this.readonly = true
      }
    },
    editOrderEdit(){
      this.isEmptyErrors = true
      this.openOrderEdit = true
    },
    edit (data) {
      this.isEmptyErrors = true
      if(data == 'express') {
        this.openExpress = true
        this.old_AWB=this.form.AWB
        if(this.form.AWB != '0'){
          this.readonly = false
        }else{
          this.readonly = true
        }
        this.openTransport = false
        
        this.openTerminal = false
        
      }
      if(data == 'transport') {
        this.openTransport = true
        this.old_transport_store_number=this.form.transport_store_number
        if(this.form.transport_store_number != '0'){
          this.readonly = false
        }else{
          this.readonly = true
        }
        this.openExpress = false
        
        this.openTerminal = false
        
      }
      if(data == 'terminal') {
        this.openTerminal = true
        this.old_terminal_store_number=this.form.terminal_store_number
        if(this.form.terminal_store_number != '0'){
          this.readonly = false
        }else{
          this.readonly = true
        }
        this.openExpress = false
        
        this.openTransport = false
        /*if(this.form.terminal_express_id){
          this.terminal_express_id=this.form.terminal_express_id
        }*/
      }
    },
    cancelOrderEdit(){
      this.isEmptyErrors = true
      this.openOrderEdit = false
    },
    cancel (data) {
      this.isEmptyErrors = true
      if(data == 'express') {
        this.openExpress = false
        this.form.express = ''
        _.each(this.expressList, item => {
          if(this.shipping_info.express == item.name){
            this.form.express = item.id
          }
        })
        this.form.AWB = this.shipping_info.AWB
        this.form.tracking_url = this.shipping_info.ship_url
      }
      if(data == 'transport') {
        this.openTransport = false
        this.form.transport_express_id = ''
        _.each(this.transportList, item => {
          if(this.shipping_info.transport_express == item.name){
            this.form.transport_express_id = item.id
          }
        })
        this.form.transport_store_number = this.shipping_info.transport_store_number
        this.form.transport_ship_url = this.shipping_info.transport_ship_url
      }
      if(data == 'terminal') {
        this.openTerminal = false
        this.form.terminal_express_id = ''
        _.each(this.expressList, item => {
          if(this.shipping_info.terminal_express == item.name){
            this.form.terminal_express_id = item.id
          }
        })
        this.form.terminal_store_number = this.shipping_info.terminal_store_number
        this.form.terminal_ship_url = this.shipping_info.terminal_ship_url
      }
    },
    async submitOrderEdit(){
      if(!this.form.business_order_no){
        this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '商家订单号是必填项'}
            ]
          }
        return
      }
      let res = await api.post(this, {
          path: 'order.php',
          api: 'change_merchant_store_number',
          data: {order_id:this.order.id,order_shipping_info_id:this.groupOrderLine[0].shipping_id,merchant_order_no:this.form.business_order_no},
          loading: 'ordernoloading'
      })
      res = res.body
      if (res.status == 'ok') {
        this.groupOrderLine[0].business_order_no=this.form.business_order_no
        this.openOrderEdit = false
      }
    },
    submit (val) {
      let update_shipping_type 
      this.form.goods_info = this.groupOrderLine[0].image_info
      this.form.goods_list = []
      _.each(this.groupOrderLine, line => {
          this.form.goods_list.push({
            id: line.id,
            num: line.number
          })
      })
      let reg = /[0-9a-zA-Z\-]*/
      if(val == 'express'){
        update_shipping_type = 'AWB'
        if(this.old_AWB && (!reg.test(this.form.AWB) || this.form.AWB.length >= MaxCharNumber || this.form.AWB.length == 0)){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的物流单号,必须有字母或者数字,不超过40个字符'}
            ]
          }
          return
        }
        if(this.express == '') {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '快递公司是必填项'}
            ]
          }
          return
        }
        if(!this.expressSelect && this.express){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的快递公司,并在下拉框中选择该快递公司'}
            ]
          }
          return
        }
      }
      if(val == 'transport'){
        update_shipping_type = 'transport'
        if(this.old_transport_store_number && (!reg.test(this.form.transport_store_number) || this.form.transport_store_number.length >= MaxCharNumber || this.form.transport_store_number.length == 0)){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的转运单号,必须包含数字,可以有字母,-,不超过40个字符'}
            ]
          }
          return
        }
        if(this.transport_express == '') {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '转运公司是必填项'}
            ]
          }
          return
        }
        if(!this.transportSelect && this.transport_express){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的转运公司,并在下拉框中选择该转运公司'}
            ]
          }
          return
        }
      }
      if(val == 'terminal'){
        update_shipping_type = 'terminal'
        if(this.old_terminal_store_number && (!reg.test(this.form.terminal_store_number) || this.form.terminal_store_number.length >= MaxCharNumber || this.form.terminal_store_number.length == 0)){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的物流单号,必须有字母或者数字,不超过40个字符'}
            ]
          }
          return
        }
        if(this.terminal_express == '') {
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '快递公司是必选项'}
            ]
          }
          return
        }
        if(!this.terminalSelect && this.terminal_express){
          this.isEmptyErrors = false
          this.errors = {
            business_name: [
              {message: '请输入正确的快递公司,并在下拉框中选择该快递公司'}
            ]
          }
          return
        }
      }
      this.$refs['form'].validate(async (valid, errors) => {
        this.isEmptyErrors = _.isEmpty(errors)
        this.errors = errors

        const submitHandler = async (update_shipping_type)=>{
          let res 
          if(this.order.type =='0'){
            res = await api.post(this, {
              path: 'order.php',
              api: 'upload_shipping_info_v2',
              data: {
                shipping_info_id: this.shipping_info.shipping_info_id,
                order_id: this.order.id,
                express_id: this.form.express,
                AWB: this.form.AWB,
                goods_list: this.form.goods_list,
                update_time: this.order.update_time,
                ship_url: this.form.tracking_url,
                need_transport: '1',
                transport_express_id: this.form.transport_express_id,
                transport_store_number: this.form.transport_store_number,
                transport_ship_url: this.form.transport_ship_url,
                terminal_express_id: this.form.terminal_express_id,
                terminal_store_number: this.form.terminal_store_number,
                terminal_ship_url: this.form.terminal_ship_url,
                update_shipping_type:update_shipping_type,
                //business_need_entrust:this.seller_delegate_switch,
                //transport_need_entrust:this.transport_delegate_switch
              },
              loading: val+'loading'
            })
          }
          if(this.order.type =='2'){
            res = await api.post(this, {
              path: 'order.php',
              api: 'upload_shipping_info_mp',
              data: {
                type: this.order.shipping_type,
                shipping_info_id: this.shipping_info.shipping_info_id,
                order_id: this.order.id,
                express_id: this.form.express,
                AWB: this.form.AWB,
                goods_list: this.form.goods_list,
                goods_info: this.form.goods_info,
                update_time: this.order.update_time,
                ship_url: this.form.tracking_url,
                need_transport: '1',
                transport_express_id: this.form.transport_express_id,
                transport_store_number: this.form.transport_store_number,
                transport_ship_url: this.form.transport_ship_url,
                terminal_express_id: this.form.terminal_express_id,
                terminal_store_number: this.form.terminal_store_number,
                terminal_ship_url: this.form.terminal_ship_url,
                update_shipping_type:update_shipping_type
              },
              loading: val+'loading'
            })
          }

          res = res.body
          if (res.status == 'ok') {
            this.shipping_info.AWB = this.form.AWB
            _.each(this.expressList, item => {
              if(this.form.express == item.id){
                this.shipping_info.express = item.name
              }
            })
            this.shipping_info.ship_url = this.form.ship_url
            this.shipping_info.transport_store_number = this.form.transport_store_number
            _.each(this.transportList, item => {
              if(this.form.transport_express_id == item.id){
                this.shipping_info.transport_express = item.name
              }
            })
            this.shipping_info.transport_ship_url = this.form.transport_ship_url
            this.shipping_info.terminal_store_number = this.form.terminal_store_number
            _.each(this.expressList, item => {
              if(this.form.terminal_express_id == item.id){
                this.shipping_info.terminal_express_id = item.name
              }
            })
            this.shipping_info.terminal_ship_url = this.form.terminal_ship_url
            Object.assign(this.order, res.result)
            if(this.order.goods_list && this.order.goods_list.length)
              this.groupOrderLine[0].shipping_id=this.order.goods_list.find(i=>i.id==this.groupOrderLine[0].id).shipping_id
            _.each(this.order.goods_list, good => {
              if (good.status == 3 || good.status == 7) {
                good.package_id = good.cancel_time
              }
            })
            this.isChange=true;
            this.order.update_time = res.result.update_time
            this.update_order=res.result;
            this.openExpress = false
            this.openTransport = false
            this.openTerminal = false
            this.getPackage()
            //this.getInfo()
            
          }
        }
        if (valid) {
          if(update_shipping_type=='AWB'){
            let checkres
            checkres = await api.post(this, {
                path: 'order.php',
                api: 'check_merchant_store_number_exist',
                data: {order_id:this.order.id,merchant_id:this.order.business_id,merchant_store_number:this.form.AWB},
                loading: 'loading'
            })
            if(checkres.body.result.length){
              this.$confirm(`物流单号已被任务${checkres.body.result.join(',')}使用过，确认继续吗?`, '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                submitHandler(update_shipping_type)
              }).catch(() => {
                          
              });
            }
            else
              submitHandler(update_shipping_type)
          }
          else
            submitHandler(update_shipping_type)
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.spec{
  word-break: break-all;
  color: #888888;
  line-height: 24px;
  span {
    display: block;
  }
}
.hearderLogo {
    position: absolute;
    width: 80%;
    top: 0;
    left: 10%;
    .header {
        padding: 50px 0;
    }
}
.trackBody {
    overflow: hidden;
    width: 980px;
    margin: 72px auto 60px;
    background: #ffffff;
    padding: 40px 5px 40px 60px;

    
    .trackTitle {
        font-size: 18px;
        color: #333333;
        font-weight:500;
        letter-spacing:2px;
        margin-bottom: 61px;
        padding-right: 55px;
    }
    .leftContent {
      width: 50%;
      float: left;
      text-align: left;

      .order-line {
        margin-bottom: 30px;

        &:last-child {
          margin-bottom: 0;
        }
        .img-container {
          float: left;
          width: 120px;
          height: 120px;
          a {
            position: relative;
            overflow: hidden;
            display: block;
            width: 120px;
            height: 120px;

            .goodsNum{
              position: absolute;
              bottom: 0;
              right:0;
              display: inline-block;
              height: 20px;
              width: 20px;
              border: 1px solid #D7D7D7;
              border-radius: 50%;
              text-align: center;
              font-size: 10px;
              line-height: 16px;
              color: #333333;
              background: #fff;
            }
          }

          img {
            height: 120px;
            width: 120px;
            -o-object-fit: contain;
            object-fit: contain;
          }
        }
        .order-des {
          position: relative;
          min-height: 120px;
          float: left;
          margin-top: 5px;
          margin-left: 20px;
          width: 60%;

          .name {
            font-size:14px;
            color:rgba(51,51,51,1);
            line-height:20px;
            text-align: left;
          }
        }

        p {
          font-size:14px;
          color:#333333;
          line-height:17px;
          margin-bottom: 6px;

          span {
            color: #888;
            font-size:14px;
          }
          a {
            color: #333333;
            word-break: break-all;
          }
        }

        .price {
          font-size:18px;
          color:rgba(51,51,51,1);
          line-height:25px;
          position: absolute;
          min-width: 200px;
          bottom: 0;
          margin: 0;
        }
      }
      .title {
        color: #333333;
        font-size: 14px;
      }
      
    }
    .rightContent {
      width: 50%;
      float: right;
      text-align: left;
      padding-right: 60px;
      padding-left: 20px;
      dl {
        max-height: 400px;
        color: #333;
        border-bottom: 1px solid #D7D7D7;
        padding: 10px 0;
        margin-bottom: 10px;

        dt {
          margin-bottom: 20px;
          color: #333333;
          
        }

        dd {

          padding:20px 0;
          .date {
            min-height: 24px;
            line-height: 17px;
            color: #888;
            padding:0px 0 0px 11px;
            font-size: 12px;
            margin-right: 10px;
            word-break: keep-all;
            text-align:center;
          }

          p {
            color: #666666;
            line-height: 24px;
          }
          &:nth-child(odd) {
            background-color: #f3f3f9;
          }
          &:nth-child(2) {
            .circle {
              background-color: #0064D8;
            }
          }
          &:last-child {
            .border {
              display: none;
            }
          }

          .step-con {
            position: relative;
          }
          .circle {
            width: 20px;
            height: 20px;
            border-radius: 100%;
            background-color: #858585;
            position: relative;
            z-index: 999;

            .current {
              background-color: #0064D8;
            }
          }

          .express-detail {
            position: relative;
            line-height: 20px;
          }

          .border {
            width: 6px;
            height: 100%;
            min-height: 70px;
            background-color: #E7EAF4;
            position: absolute;
            left: -23px;
            top: 50%;
          }
        }
      }
      .order-info {
        margin-bottom: 10px;
        line-height: 20px;
        position: relative;
        padding-right: 40px;

        .expressList {
          display: inline-block;
          color: #333;
          font-size: 14px;
        }
        .editIcon {
          cursor: pointer;
          position: absolute;
          right: 20px;
          top: 5px;
          width: 10px;
          height: 10px;
          background: url('../../../ico/el-icon-editcopy@2x.png');
          background-size: cover;
        }

        .cancel {
          display: inline-block;
          width:49%;
          height:45px;
          border-radius:3px;
          border:1px solid rgba(15,102,207,1);
          vertical-align: top;
          color: #0F66CF;
          text-align: center;
          line-height: 45px;
          cursor: pointer;
        }
      }
      
    }

}
  .dialog-form {
    padding-bottom: 40px;
  }
  @media screen and (max-width: 769px) {
    .trackBody {
      width: 100% !important;
      padding: 10px 0 !important;
      margin: 0px auto 60px;

      .trackTitle {
        padding-right: 0px !important;
        padding-bottom: 10px;
        border-bottom: 1px solid #D7D7D7;
      }
      .leftContent {
        width: 100%;
        ul {
          padding: 0 10px;
          border-bottom: 1px solid #D7D7D7;
        }
        .order-line {
          .order-des {
            height: 90px !important;
          }

          .img-container {
            width: 80px;
            height: 80px;

            a {
              width: 80px;
              height: 80px;
              img {
                height: 80px;
                width: 80px;
            
              }
            }
          }
        }

        .mobile_address {
          margin-top: 10px !important;
          padding: 10px;
          border-bottom: 1px solid #D7D7D7;
        }
      }

      .rightContent {
        width: 100%;
        padding-right: 10px !important;
        padding-left: 10px !important;

        .order-info {
          padding-right: 0 !important;

          .dialog-form {
            padding-bottom: 10px;
          }
        }
      }
    }
  }  
</style>



// WEBPACK FOOTER //
// src/pages/orders/list/OrderTrackDialog.vue